import { useContext } from "react";
import { DamageRecognitionContext } from "../contexts/DamageRecognitionContext";

const useDamageRecognition = () => {
  const context = useContext(DamageRecognitionContext);

  if (context === undefined) {
    throw new Error(
      "useDamageRecognition must be used within DamageRecognitionProvider",
    );
  }

  return context;
};

export default useDamageRecognition;
